import { ParsedAssistantMessage, StructuredAssistantResponse } from './types'

/**
 * Attempts to parse an assistant message as structured JSON.
 * Falls back gracefully to plain text if parsing fails.
 */
export function parseStructuredResponse(content: string): ParsedAssistantMessage {
    const trimmed = content.trim()

    // Try to extract JSON from the response
    // LLMs sometimes wrap JSON in markdown code blocks
    const jsonMatch =
        trimmed.match(/```json\s*([\s\S]*?)\s*```/) ||
        trimmed.match(/```\s*([\s\S]*?)\s*```/) ||
        [null, trimmed]

    const potentialJson = jsonMatch[1] || trimmed

    try {
        const parsed = JSON.parse(potentialJson) as StructuredAssistantResponse

        // Validate required fields
        if (typeof parsed.response !== 'string') {
            throw new Error('Missing response field')
        }

        return {
            isStructured: true,
            text: parsed.response,
            citations: Array.isArray(parsed.citations) ? parsed.citations : [],
            categories: Array.isArray(parsed.categories) ? parsed.categories : [],
            rawContent: content
        }
    } catch {
        // Parsing failed - return as plain text
        return {
            isStructured: false,
            text: content,
            citations: [],
            categories: [],
            rawContent: content
        }
    }
}
